import { render, staticRenderFns } from "./PayFastPaymentGateway.vue?vue&type=template&id=1c43af6e&scoped=true&"
import script from "./PayFastPaymentGateway.vue?vue&type=script&lang=js&"
export * from "./PayFastPaymentGateway.vue?vue&type=script&lang=js&"
import style0 from "./PayFastPaymentGateway.vue?vue&type=style&index=0&id=1c43af6e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c43af6e",
  null
  
)

export default component.exports